import React, { useEffect, useState } from "react";

import Header from "./Header";
import "./Accomodation.css";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Navigate, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
// import ConcellationRefund from "./ConcellationRefund";
import "./BillingDetails.css";
import host from "../config";
const PreviewPage = () => {
  // let host = "https://api.vmrdarental.com";
  // let host = "https://api.vmrdarental.com";

  const navigate = useNavigate();

  const [panValidation, setPanValidation] = React.useState(true);
  const [proofValidation, setProofValidation] = React.useState(true);
  const [proofType, setProofType] = React.useState("pan");
  const [aadhaar, setAadhaar] = useState("");
  const [selectedPurpose, setSelectedPurpose] = useState("");
  const [filteredBookingDetails, setFilteredBookingDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [proofValue, setProofValue] = React.useState("pan");
  const handleAadhaarChange = (e) => {
    setAadhaar(e.target.value);
    billingRequest.aadhaar = e.target.value;
  };

  const handleProofTypeChange = (e) => {
    setProofType(e.target.value);
    setProofValidation(true); // Reset validation when changing proof type
    console.log("Proof Type:", e.target.value);
    // Add a console.log to check proofType and the Aadhaar input
    console.log("Aadhaar Value:", aadhaar);
  };

  const validateProof = (proofValue, proofType) => {
    if (proofType === "aadhaar") {
      const aadhaarRegex = /^\d{12}$/;
      return aadhaarRegex.test(proofValue);
    } else if (proofType === "pan") {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      return panRegex.test(proofValue);
    }
    return false;
  };

  const handleProofInput = (e) => {
    const value = e.target.value;
    setProofValue(value);

    let isValid = true;

    switch (proofType) {
      case "pan":
        isValid = /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value);
        break;
      case "aadhaar":
        isValid = /^[0-9]{12}$/.test(value);
        break;
      case "voter_id":
        isValid = /^[A-Z]{3}[0-9]{7}$/.test(value);
        break;
      case "passport":
        isValid = /^[A-Z][0-9]{7}$/.test(value);
        break;
      case "govt_id":
        isValid = true; // No strict validation
        break;
      default:
        isValid = false;
    }

    setProofValidation(isValid);
  };

  const validatePanCard = (panCard) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    return panRegex.test(panCard);
  };

  const handlePanInput = (e) => {
    const panValue = e.target.value.toUpperCase();
    setPanValidation(validatePanCard(panValue));
  };

  localStorage.removeItem("bookingDetailsDataFinal");
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    localStorage.removeItem("bookingDetailsData");
  }
  // if (localStorage.getItem("bookingDetailsData") == undefined) {
  //   navigate("/Accommodation", "_self");
  // }
  let bookingDetailsData = localStorage.getItem("selectedRoomData");
  if (bookingDetailsData) {
    bookingDetailsData = JSON.parse(bookingDetailsData);
  } else {
    navigate("/", "_self");
  }
  console.log("bookungD", bookingDetailsData);
  // console.log(bookingDetailsDataFinal,"datafinal")
  const [grandAmountFinal, setGrandAmountFinal] = React.useState(0);
  const [bookingDetailsDataFinal, setBookingDetailsDataFinal] = React.useState(
    []
  );
  const [paymentEncyData, setPaymentEncyData] = React.useState("");

  let sumGrandTotalAmount = 0;
  let bookingDetailsDataFinalTmp = [];
  let seqNo = 1;
  let srNo = 0;
  // let grandTotal = 0;
  let billingRequest = JSON.parse("{}");
  let captchSumValue = 0;

  bookingDetailsData.selectedRooms.map((e, i) => {
    for (let i = 0; i < bookingDetailsData.daysStay; i++) {
      let roomObj = JSON.parse(JSON.stringify(e));
      let tmpDate = new Date(bookingDetailsData.fromDate);
      tmpDate.setDate(tmpDate.getDate() + i);
      roomObj.bookingDate = tmpDate;
      roomObj.rmSeqId = seqNo;
      roomObj.selectedPersons = roomObj.persons;
      roomObj.grandTotalVal = roomObj.amount;
      roomObj.finalGrandTotalVal = roomObj.amount;
      roomObj.purpose = roomObj.purpose;
      bookingDetailsDataFinalTmp.push(roomObj);

      sumGrandTotalAmount = sumGrandTotalAmount + e.amount;
      seqNo++;
    }
  });

  console.log(bookingDetailsDataFinalTmp, "bookingDetailsDataFinalTmp");

  // const grandTotal = filteredBookingDetails.reduce(
  //   (total, item) => total + item.amount,
  //   0
  // );

  useEffect(() => {
    setGrandAmountFinal(sumGrandTotalAmount);
    setBookingDetailsDataFinal(bookingDetailsDataFinalTmp);
  }, []);

  if (
    localStorage.getItem("bookingDetailsDataFinal") !== undefined &&
    localStorage.getItem("bookingDetailsDataFinal") !== null
  ) {
    bookingDetailsDataFinal = JSON.parse(
      localStorage.getItem("bookingDetailsDataFinal")
    );
    setBookingDetailsDataFinal(bookingDetailsDataFinal);
  }
  console.log("final booking", bookingDetailsDataFinal);
  const handleMobileNumberInput = (e) => {
    const maxLength = 10;
    let inputValue = e.target.value;

    // Trim input to the maximum length
    if (inputValue.length > maxLength) {
      inputValue = inputValue.slice(0, maxLength);
      e.target.value = inputValue;
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Group booking details by date range
  const groupedBookingDetails = React.useMemo(() => {
    const groupedData = {};

    bookingDetailsData.selectedRooms.forEach((room) => {
      const key = `${bookingDetailsData.fromDate}-${bookingDetailsData.toDate}`;

      if (!groupedData[key]) {
        groupedData[key] = {
          location_id: room.location_id,
          amount: bookingDetailsData.selectedRooms.amount,
          fromDate: bookingDetailsData.fromDate,
          toDate: bookingDetailsData.toDate,
          totalAmount: 0,
        };
      }

      groupedData[key].totalAmount += room.amount;
    });

    return Object.values(groupedData); // Convert grouped data to an array
  }, [bookingDetailsData]);

  // Calculate the grand total
  const grandTotal = groupedBookingDetails.reduce(
    (total, entry) => total + entry.totalAmount,
    0
  );

  const generateRandomNumber = () => {
    const min = 1;
    const max = 9;
    let captchVal = Math.floor(Math.random() * (max - min + 1)) + min;
    captchSumValue = captchSumValue + captchVal;
    return captchVal;
  };

  const proceedToPay1 = () => {
    let validationResult = proceedToPayValidation();
    if (validationResult === false) {
      return;
    }
    setShowModal(true); // Show the modal when "Proceed to Pay" is clicked
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const proceedToPayValidation = () => {
    if (
      document.getElementById("customer_name").value === undefined ||
      document.getElementById("customer_name").value === ""
    ) {
      alert("Please provide the valid customer name");
      return false;
    }
    if (
      document.getElementById("customer_address").value === undefined ||
      document.getElementById("customer_address").value === ""
    ) {
      alert("Please provide the valid customer address");
      return false;
    }

    const mobileNumber = document.getElementById("customer_contactno").value;
    if (
      mobileNumber === undefined ||
      mobileNumber === "" ||
      mobileNumber.length !== 10 ||
      isNaN(mobileNumber)
    ) {
      alert("Please provide a valid 10-digit mobile number");
      return false;
    }

    if (
      document.getElementById("customer_email").value === undefined ||
      document.getElementById("customer_email").value === ""
    ) {
      alert("Please provide the valid customer email");
      return false;
    }

    const fileInput = document.getElementById("uploadedFile");
    if (!fileInput.files || fileInput.files.length === 0) {
      alert("Please upload a file");
      return false;
    }

    if (!document.getElementById("termsandconditions").checked) {
      alert("Please click the checkbox to accept the terms and conditions.");
      return false;
    }

    return true;
  };

  const handleFileUpload = async (event) => {
    const fileInput = event.target.files[0];
    if (fileInput) {
      const formData = new FormData();
      formData.append("image", fileInput); // Ensure 'image' matches the field name used in the backend

      try {
        const response = await fetch(`${host}/upload`, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        if (response.ok) {
          console.log("File uploaded successfully:", result.location); // Use 'result.location' here
          billingRequest.uploadedFile = result.location; // Store the file URL in the billing request
          localStorage.setItem("uploadedFile", result.location);
        } else {
          alert("File upload failed!");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        alert("File upload failed!");
      }
    }
  };
  const uploadedFileURL = localStorage.getItem("uploadedFile");
  const proceedToPay = () => {
    billingRequest.locationId = bookingDetailsData.locationId;
    billingRequest.name = document.getElementById("customer_name").value;
    billingRequest.address = document.getElementById("customer_address").value;
    billingRequest.contactno =
      document.getElementById("customer_contactno").value;
    billingRequest.email = document.getElementById("customer_email").value;

    billingRequest.pan =
      proofType === "pan" ? document.getElementById("customer_pan").value : "";
    billingRequest.aadhaar =
      proofType === "aadhaar"
        ? document.getElementById("customer_aadhaar").value
        : "";
    billingRequest.termsAndConditions =
      document.getElementById("termsandconditions").checked;

    // billingRequest.uploadedFile = billingRequest.uploadedFile;
    billingRequest.uploadedFile =
      billingRequest.uploadedFile || localStorage.getItem("uploadedFile");

    if (!billingRequest.uploadedFile) {
      alert("Please upload a file before proceeding to payment.");
      return;
    }
    // billingRequest.purpose = document.getElementById("purpose").value;
    billingRequest.rooms = bookingDetailsData;
    billingRequest.roomData = bookingDetailsDataFinal;

    // Add calculated amount
    billingRequest.totalAmount = grandAmountFinal;

    // Store billingRequest in local storage
    localStorage.setItem("billingRequest", JSON.stringify(billingRequest));
    console.log("Billing Request:", billingRequest);

    // Make API call
    fetch(host + "/proceed-room-booking", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("access_token"),
      },
      body: JSON.stringify(billingRequest),
    })
      .then((data) => {
        if (data.status == 403) {
          alert(
            "We regret to inform you that we are currently unable to process your request. Kindly try again later"
          );
          navigate("/");
          return;
        }
        if (data.status === 401) {
          alert("Session expired. Please log in and try again.");
          navigate("/Login");
          return;
        }
        data.json().then((res) => {
          console.log("API Response:", res);
          if (res.amount !== grandAmountFinal) {
            console.error("Amount mismatch:", res.amount, grandAmountFinal);
          }

          // document.getElementById("encRequest").value = res.data;
          document.getElementById("order_id").value = res.data;
          document.getElementById("amount_id").value = res.amount;
          document.getElementById("key_id").value = res.apiKey;

          document.redirect.submit();
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleBack = () => {
    // Clear localStorage data related to the booking
    localStorage.removeItem("selectedRoomData");
    localStorage.removeItem("bookingDetailsDataFinal");

    // Navigate back to the booking page
    navigate("/"); // Replace with the correct route for your `BookingComponent`
  };

  const getInputValue = (id, fallback = "N/A") => {
    return document.getElementById(id)?.value.trim() || fallback;
  };

  const proofTypes = [
    "pan",
    "aadhaar",
    "passport",
    "voter_id",
    "driving_license",
  ]; // Add more as needed

  const customerDetails = {
    name: getInputValue("customer_name"),
    contactNo: getInputValue("customer_contactno"),
    address: getInputValue("customer_address"),
    email: getInputValue("customer_email"),
    proofType: getInputValue("proof_type"),
    proof: getProofValue(getInputValue("proof_type")),
  };

  function getProofValue(selectedProofType) {
    return proofTypes.includes(selectedProofType)
      ? getInputValue(`customer_${selectedProofType}`)
      : "";
  }

  console.log(customerDetails);

  return (
    <div>
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            {/* <h2>Booking and Customer Details</h2> */}

            {/* Displaying Customer Details */}
            <h5>Customer Information</h5>
            <table className="table">
              <thead>
                <tr>
                  {/* <th>Field</th>
                  <th>Details</th> */}
                  <th>Name</th>
                  <th>Contact No.</th>
                  <th>Address</th>
                  <th>Email</th>
                  <th>Proof Type</th>
                  <th>Proof</th>
                  <th>Uploaded File</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{customerDetails.name}</td>
                  <td>{customerDetails.contactNo}</td>
                  <td>{customerDetails.address}</td>
                  <td>{customerDetails.email}</td>
                  <td>{customerDetails.proofType}</td>
                  <td>{customerDetails.proof}</td>
                  <td>
                    {uploadedFileURL ? (
                      <>
                        <a href={uploadedFileURL} download>
                          <button className="btn-primary">View</button>
                        </a>
                      </>
                    ) : (
                      "No file uploaded"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Displaying Booking Details */}
            <h5>Booking Information</h5>

            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Venue Name</th>
                  <th>Venue Type</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>Amount per Day</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {bookingDetailsData && (
                  <tr>
                    <td>{bookingDetailsData.locationName}</td>
                    <td>{bookingDetailsData.roomName}</td>
                    {/* <td>{bookingDetailsData.locationId}</td> */}
                    <td>{formatDate(bookingDetailsData.fromDate)}</td>
                    <td>{formatDate(bookingDetailsData.toDate)}</td>
                    <td>{bookingDetailsData.selectedRooms[0].amount}</td>
                    <td>{grandAmountFinal}</td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="action-button">
              <button className="back_button float_left" onClick={closeModal}>
                Close
              </button>
              <button
                className="booking_button float_right"
                onClick={proceedToPay}
                style={{ whiteSpace: "nowrap" }}
              >
                Proceed to Pay
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="container">
        <div className="row">
          {/* <div className="col-lg-2"></div> */}

          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
            <div className="row">
              {/* <div className="col-md-3 center"></div> */}
              <div className="col-md-12 center billing_details_form">
                <form>
                  {/* Row 1 */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="customer_name">Name</label>
                        <input
                          type="text"
                          name="name"
                          className="form-control billing_details_form-control"
                          id="customer_name"
                          placeholder="Name"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="customer_contactno">Contact No.</label>
                        <input
                          type="text"
                          name="mobileNumber"
                          className="form-control billing_details_form-control"
                          id="customer_contactno"
                          placeholder="Contact No"
                          onInput={(e) => handleMobileNumberInput(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="customer_address">Address</label>
                        <input
                          name="address"
                          //   style={{ minHeight: 100 }}
                          className="form-control billing_details_form-control"
                          id="customer_address"
                          placeholder="Address"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="customer_email">E-mail</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control billing_details_form-control"
                          id="customer_email"
                          placeholder="E-Mail"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="proof_type">Proof Type</label>
                        <select
                          className="form-control billing_details_form-control"
                          id="proof_type"
                          value={proofType}
                          onChange={handleProofTypeChange}
                          style={{ paddingTop: "5px" }}
                        >
                          <option value="pan">PAN</option>
                          <option value="aadhaar">Aadhaar</option>
                          <option value="govt_id">Government ID</option>
                          <option value="voter_id">Voter ID</option>
                          <option value="passport">Passport</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor={`customer_${proofType}`}>
                          Proof ({proofType.toUpperCase().replace("_", " ")})
                        </label>
                        <input
                          type="text"
                          name={proofType}
                          className={`form-control billing_details_form-control ${
                            proofType !== "govt_id" && !proofValidation
                              ? "is-invalid"
                              : ""
                          }`}
                          id={`customer_${proofType}`}
                          placeholder={`Proof (${proofType.toUpperCase().replace("_", " ")})`}
                          onBlur={handleProofInput}
                        />
                        {proofType !== "govt_id" && !proofValidation && (
                          <div className="invalid-feedback">
                            Invalid {proofType.toUpperCase().replace("_", " ")}{" "}
                            number
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Row 3 */}
                  {/* <div className="row"></div> */}

                  {/* Row 4 */}
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="file_upload">Upload File</label>
                        <input
                          type="file"
                          id="uploadedFile"
                          name="uploadedFile"
                          className="form-control"
                          onChange={handleFileUpload}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="form-group"
                        style={{
                          display: "flex",
                          alignItems: "center", // Vertically aligns checkbox with the text
                          flexDirection: "row",
                          justifyContent: "center",
                          fontSize: "16px", // Aligns the checkbox to the left
                        }}
                      >
                        <input
                          className="largerCheckbox"
                          type="checkbox"
                          id="termsandconditions"
                          style={{
                            margin: "0 8px 0 0", // Adds slight spacing between the checkbox and text
                          }}
                        />
                        <label
                          htmlFor="termsandconditions"
                          style={{ margin: "10px", fontSize: "16px" }}
                        >
                          I agree to the above specified{" "}
                          <a
                            href="/termsandconditions"
                            target="_blank"
                            style={{ textDecoration: "underline" }}
                          >
                            Terms and Conditions
                          </a>
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Venue Name</th>
                  <th>Venue Type</th>

                  <th>From Date</th>
                  <th>To Date</th>
                  <th> Days</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {bookingDetailsData && (
                  <tr>
                    <td style={{ textAlign: "center" }}>
                      {bookingDetailsData.locationName}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {bookingDetailsData.roomName}
                    </td>
                    {/* <td>{bookingDetailsData.locationId}</td> */}
                    <td style={{ whiteSpace: "nowrap" }}>
                      {formatDate(bookingDetailsData.fromDate)}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {formatDate(bookingDetailsData.toDate)}
                    </td>
                    <td>{bookingDetailsData.daysStay}</td>
                    <td style={{ textAlign: "right" }}>{grandAmountFinal}</td>
                  </tr>
                )}
              </tbody>
            </table>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Rent</th>
                  <th>GST</th>
                  <th>Cleaning Charges</th>
                  <th>Security Deposit</th>
                  <th>Total Amount Per Day</th>
                </tr>
              </thead>
              <tbody>
                {bookingDetailsData && (
                  <tr>
                    <td style={{ textAlign: "right" }}>
                      {bookingDetailsData.selectedRooms[0].price}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {bookingDetailsData.selectedRooms[0].gst}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {bookingDetailsData.selectedRooms[0].cleaning_charges}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {bookingDetailsData.selectedRooms[0].security_deposit}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {bookingDetailsData.selectedRooms[0].amount}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <button
              className="booking_button float_right"
              onClick={() => proceedToPay1()}
            >
              Confirm Booking
            </button>

            <div className="container" style={{ paddingTop: "10%" }}>
              {/* <ConcellationRefund /> */}
            </div>
          </div>
        </div>

        <form
          method="POST"
          name="redirect"
          action="https://api.razorpay.com/v1/checkout/embedded"
        >
          <input type="hidden" name="key_id" id="key_id" value="" />
          <input type="hidden" id="order_id" name="order_id" value="" />
          <input type="hidden" id="amount_id" name="amount" value="" />
          <input
            type="hidden"
            name="callback_url"
            value="https://api.vmrdarental.com/razorpay-response"
          />
          {/* <input
            type="hidden"
            name="callback_url"
            value="http://localhost:3000/razorpay-response"
          /> */}
        </form>
      </div>
    </div>
  );
};
export default PreviewPage;
